import { Grid } from '@mui/material';
import React from 'react';
import { IMemberTestatorData } from '../../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberTestament';
import { BirthRegistrationNumberField } from '../fields/BirthRegistrationNumber/BirthRegistrationNumberField';
import { BirthRegistryOfficeField } from '../fields/BirthRegistryOffice/BirthRegistryOfficeField';

export const TestatorMemberInformation: React.FC = () => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <BirthRegistryOfficeField<IMemberTestatorData> name='birthRegistryOffice' />
        </Grid>
        <Grid item xs={6}>
          <BirthRegistrationNumberField<IMemberTestatorData> name='birthRegistrationNumber' />
        </Grid>
      </Grid>
    </>
  );
};
